export default __webpack_public_path__ + "static/media/ic_add.04b1f5a1e18041a352d4262fb92bac0c.svg";